import type { Step } from '../types/step';
import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import { stackStepQueryParams } from '../common/step_stack';

export const NNOOnboardingSteps: Step[] = [
  {
    id: 'nnoPrompt',
    pathname: '/nnoPrompt',
    queryParams: stackStepQueryParams,
    canShow: (appData: AppData) => {
      if (appData.isFromMAL) {
        return false;
      }
      if (!appData.selectedService?.insurance) {
        return false;
      }
      return !!appData.signupParams?.needNNOInsurance;
    },
    hasData: () => true,
    hasOwnData: () => true,
    category: () => StepCategory.Cars,
  },
  {
    id: 'householdVehicle',
    pathname: '/householdVehicle',
    queryParams: stackStepQueryParams,
    canShow: (appData) => {
      if (appData.isFromMAL) {
        return false;
      }
      if (!appData.selectedService?.insurance) {
        return false;
      }
      return !!appData.signupParams?.needNNOInsurance;
    },
    hasData: () => true,
    hasOwnData: (appData: AppData) => appData.signupParams?.hasHouseholdVehicle !== undefined,
    category: () => StepCategory.Cars,
  },
  {
    id: 'nnoIneligible',
    pathname: '/nnoIneligible',
    queryParams: stackStepQueryParams,
    canShow: (appData) => {
      if (appData.isFromMAL) {
        return false;
      }
      if (!appData.selectedService?.insurance) {
        return false;
      }
      return !!appData.signupParams?.needNNOInsurance && !!appData.signupParams?.hasHouseholdVehicle;
    },
    hasData: () => true,
    hasOwnData: (appData: AppData) => appData.signupParams?.hasHouseholdVehicle !== undefined,
    category: () => StepCategory.Cars,
  },
  {
    id: 'nnoConfirm',
    pathname: '/nnoConfirm',
    queryParams: stackStepQueryParams,
    canShow: (appData) => {
      if (appData.isFromMAL) {
        return false;
      }
      if (!appData.selectedService?.insurance) {
        return false;
      }
      return !!appData.signupParams?.needNNOInsurance;
    },
    hasData: () => true,
    hasOwnData: () => true,
    category: () => StepCategory.Cars,
  },
  {
    id: 'nnoDriverLicense',
    pathname: '/nnoDriverLicense',
    queryParams: stackStepQueryParams,
    canShow: (appData) => {
      if (appData.isFromMAL) {
        return false;
      }
      if (!appData.selectedService?.insurance) {
        return false;
      }
      return !!appData.signupParams?.needNNOInsurance;
    },
    hasData: () => true,
    hasOwnData: () => true,
    category: () => StepCategory.Cars,
  },
];
